import { getDictPhrase } from "../../../common";
export const getBetStatusLabelProps = (bet, state) => {
    return {
        settlementStatus: bet.settlementStatus,
        phrase: getDictPhrase(state.dict, bet.settlementStatus)
    };
};
//# sourceMappingURL=getBetStatusLabelProps.js.map